export default {"src":"/_next/static/media/logo.7cd18d4a.svg","height":156,"width":131,"blurWidth":0,"blurHeight":0};